export default "__VITE_ASSET__C0m6OZsF__"